import { render } from "./HayCambios.vue?vue&type=template&id=3f4070b8&scoped=true"
import script from "./HayCambios.vue?vue&type=script&lang=js"
export * from "./HayCambios.vue?vue&type=script&lang=js"

import "./HayCambios.vue?vue&type=style&index=0&id=3f4070b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f4070b8"]])

export default __exports__